import {
    buildConfigSliceWithGridSupport,
    useConfigSlice,
    WidgetConfigSliceActionPayloadType,
} from 'widgets/store/configuration/configSlice';
import { WidgetType } from 'widgets/WidgetType';
import {
    initialOutliersConfigState,
    OutliersConfigState,
} from './OutliersConfigState';
import { selectOutliersWidgetState } from 'widgets/outliers/store/selectors';
import { OutliersColumn } from 'widgets/outliers/components/grid/columns';

export const buildOutliersConfigSlice = () =>
    buildConfigSliceWithGridSupport<OutliersColumn, OutliersConfigState>(
        WidgetType.OUTLIERS_WIDGET,
        selectOutliersWidgetState,
        initialOutliersConfigState,
        { postReducer: upgradeConfig }
    );

export const useOutliersConfigSlice = () =>
    useConfigSlice(buildOutliersConfigSlice());

export type OutliersWidgetConfigPayloadType =
    WidgetConfigSliceActionPayloadType<OutliersConfigState>;

function upgradeConfig(
    config: OutliersConfigState | undefined
): OutliersConfigState {
    const ret = config || initialOutliersConfigState;
    if (ret.avgPriceDecimals === undefined) {
        ret.avgPriceDecimals = initialOutliersConfigState.avgPriceDecimals;
    }
    return ret;
}
